/* template */
<template><div class="empty"><span class="text">{{ $t('personal.empty') }}</span></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m06ad35b3"}'>
.empty
  width 600rpx
  margin 100rpx auto
  padding 40rpx 0
.text
  opacity 0.56
  font-size 24rpx
  color #666666
  text-align center
  display block
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
createComponent({
  name: 'empty',
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "empty06ad35b3",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
